import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-dialog-estimate',
    templateUrl: './dialog-estimate.component.html',
    styleUrls: ['./dialog-estimate.component.css']
})
export class DialogEstimateComponent implements OnInit {
    days: number;
    hours: number;
    min: number;

    constructor(public dialogRef: MatDialogRef<DialogEstimateComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private toastr: ToastrService,
    ) {
    }

    ngOnInit(): void {
    }

    save() {
        this.data = {

            days: this.days,
            hours: this.hours,
            min: this.min
        };
        if (this.data.days === undefined || this.data.hours === undefined || this.data.min === undefined) {
            this.toastr.info('Molimo Vas popunite sva polja.');
            return;
        }
        this.dialogRef.close(this.data);
    }

    closeModal() {

    }
}
